import { useEffect } from "react";
import stylesUrl from "@leapfinancial/kentucky-sdk/styles?url";

const STYLE_ATTR = "data-kentucky-sdk-styles";

/** Ref-count so React StrictMode remounts do not flash-remove the sheet. */
let mountCount = 0;
let activeLink: HTMLLinkElement | null = null;

/**
 * Injects Kentucky SDK CSS while CipPage is mounted and removes it on leave,
 * so post-CIP screens are not restyled by the SDK's bundled Lola 1.x CSS.
 */
export function useKentuckySdkStyles() {
  useEffect(() => {
    mountCount += 1;
    if (!activeLink) {
      const existing = document.head.querySelector<HTMLLinkElement>(
        `link[${STYLE_ATTR}]`,
      );
      if (existing) {
        activeLink = existing;
      } else {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = stylesUrl;
        link.setAttribute(STYLE_ATTR, "true");
        document.head.appendChild(link);
        activeLink = link;
      }
    }

    return () => {
      mountCount = Math.max(0, mountCount - 1);
      if (mountCount === 0 && activeLink) {
        activeLink.remove();
        activeLink = null;
      }
    };
  }, []);
}
